export default __webpack_public_path__ + "static/media/Stripes_Small_OffersIcon.87fc6256.svg";